<template>
  <section class="news-container">
    <div class="content-container">
      <div class="transparent">
        <div class="email-table">
          <div class="filter-container">
            <div class="filter-list">
              <div class="mg-b-10">
                <v-radio-group
                  v-model="merchant_platform"
                  button
                  :list="serverTypeOption"
                  @change="filterData"></v-radio-group>
              </div>
              <v-date-picker
                v-model="date"
                :format="'dd-MM-yyyy HH:mm:ss'"
                :valueFormat="'yyyy-MM-dd HH:mm:ss'"
                type="datetimerange"
                :default-time="['00:00:00', '23:59:59']"
                @change="filterData"/>
              <v-input
                v-model="email"
                placeholder="Email Address,Name"
                @keyEnter="filterData"
                @blur="filterData"></v-input>
                <!--        <v-select  @change="filterData"></v-select>-->
            </div>
          </div>
          <el-table
            ref="table"
            :data="emailList"
            style="width: 240px"
            highlight-current-row
            :header-row-class-name="headerClass"
            @row-click="rowClick"
          >
            <el-table-column
              width="240"
            >
              <template slot-scope="scope">
                <div class="flex">
                  <div class="flex-algin  flex-align-center mg-r-8">
                    <span
                      v-if="scope.row.merchant_platform"
                      class="table-icon__img">
                      <img :src="getOptionName('serverTypeIcon',scope.row.merchant_platform)" >
                    </span>
                  </div>
                  <span>
                    <p class="email-title">
                      {{scope.row.email_title}}
                    </p>
                    <p>
                      {{ scope.row.created_at }}
                    </p>
                    <!--                <p>-->
                    <!--                  {{handlerTime(scope.row.created_at)[1]}}-->
                    <!--                </p>-->
                    <p>
                      {{scope.row.to}}
                    </p>
                    <p class="content-title">
                      {{scope.row.title}}
                    </p>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <div class="email-content">
          <h2 v-if="email_title">{{email_title}}</h2>
          <div v-html="content"></div>
        </div>
      </div>
      <v-pagination
        :total="pageConfig.total"
        :pagerCount="pageCount"
        :current="pageConfig.currentPage"
        @currentChange="currentChange"
      />
    </div>
  </section>
</template>
<script>

import MixinOptions from '@/mixins/options'
import {getSmsLogList} from '@/api/admin-cms'

export default {
  name: 'emailLog',
  mixins: [MixinOptions],
  props:{
    headerClass:{
      type:Function,
      default:()=>{
        return 'headerClass'
      }
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        size:20,
        currentPage: 1,
        total: 10
      },
      emailList: [],
      date:'',
      merchant_platform:'',
      email:'',
      content:'',
      email_title: '',
      pageCount:5

    }
  },
  computed: {

  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getSmsLogList()
        // this.network().getNewsCategoriesList()
      }
    },
    emailList:{
      immediate:true,
      handler(val){
        if(val.length)
        {
          this.$nextTick(()=>{
            this.$refs.table.setCurrentRow(this.emailList[0])
            this.content = this.emailList[0].content
            this.email_title = this.emailList[0].email_title
          })
        }
      }
    }
  },
  methods: {
    rowClick(row) {
      let {content, email_title} = row
      this.content = content
      this.email_title = email_title
    },
    handlerTitle(title){
      return title['en-US']
    },
    hanlderStatus(status){
      let data = {
        0:'Fail',
        1:'Success',
        2:'Pretend'
      }
      return data[status]
    },
    handlerTime(time){
      return time = time?time.split(' '):['-','-']
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getSmsLogList()
    },
    handleTab(){
      this.pageConfig.currentPage = 1
      this.network().getSmsLogList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getSmsLogList()
    },
    network() {
      return {
        getSmsLogList: async (params = {}) => {
          const { data } = await getSmsLogList({
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            start_time:this.date?this.date[0]:'',
            end_time:this.date?this.date[1]:'',
            email:this.email,
            merchant_platform:this.merchant_platform,
            type:'email'
          })
          this.emailList = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.news-container {
  .transparent{
    // margin-top: -15px;
    display: flex;
    height: calc(100% - 55px);
    .email-table{
      padding-top: 20px;
      background: #fff;
      // height: calc(100vh - 118px);
      .email-title{
        color: #24292E;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
      }
      .content-title{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #6A737D;
      }
      ::v-deep .v-pagination{
        width: 240px;
        .el-pagination {
          white-space: pre-wrap;
        }
      }
    }
    .email-content{
      box-sizing: border-box;
      //height: 930px;
      width: 100%;
      border: 1px solid #979797;
      background-color: #DFE3E9;
      overflow-y: auto;
      overflow-x: hidden!important;
      // height: calc(100% - 118px);
      h2{
        text-align: center;
      }
    }
  }
  .content-container {
    position: relative;
    height: calc(100vh - 86px);
    .el-table {
      &::before{
        height: 0;
      }
      //margin-top: 15px;
      //border:1px solid #E1E4E8;
      overflow-y: scroll;
      overflow-x: hidden!important;
      height: calc(100% - 84px);
      border-radius: 0px!important;
      ::v-deep .el-table__body-wrapper{
        overflow-x: hidden!important;
      }
      ::v-deep .headerClass{
        background:#F6F8FA;
        display: none;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
      ::v-deep .cell{
        padding: 10px 20px;
      }
      ::v-deep .current-row{
        td{
          background-color: #0366D6;
          box-shadow: inset 0 -1px 0 0 #E1E4E8;
          p{
            color: #fff;
          }
        }
      }
    }
    .btn-list {
      text-align: center;
      span {
        margin-right: 10px;
      }
    }
    .filter-container {
      display: flex;
      //justify-content: space-between;
      //align-items: center;
      width: 240px;
      padding:0 20px;
      .filter-list {
        display: flex;
        //justify-content: space-between;
        flex-direction: column;
        .el-input{
          margin: 10px 0;
          //margin: 0 20px;
        }
      }
    }
  }
  .dialog-container {
    padding: 15px;
  }
  .ic-order {
    .svg-inline--fa {
      color: #91939A;
      font-size: 12px;
    }
  }
  .img-banner {
    width: 150px;
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      min-height: 24px;
    }
  }
  .el-table{
    p:nth-child(2){
      color: #586069;
      font-family: Inter;
      font-size: 12px;
    }
    p:nth-child(3){
      color: #24292E;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
    }
    p:last-child{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
    }
    .font-weight{
      font-weight: 500;
    }
    .content-break{
      word-break: break-word;
    }
  }
  .fail{
    color: #CB2431;
  }
}
::v-deep .el-main{
  overflow: hidden!important;
  position: fixed;
}
</style>
